import { booleanAttribute } from "#ce/utils/props";

export const densityOptions = ["default", "comfortable", "compact"];
export const variantOptions = ["outlined", "divided", "plain"];
export const controlsAlignOptions = ["center", "start"];

export const props = Object.freeze({
  /**
   * Accessible name of the list, read by screen readers before its rows.
   *
   * @type {String}
   * @default undefined
   */
  accessibleName: {
    type: String,
    default: undefined,
  },
  /**
   * Show the rows without grips, move buttons, hover or dragging.
   *
   * @type {Boolean|String}
   * @default false
   */
  readonly: booleanAttribute(),
  /**
   * Row spacing. "default" is the roomiest; "comfortable" is one step tighter; "compact" is the tightest.
   *
   * @type {String}
   * @default "default"
   * @values default, comfortable, compact
   * @storybook-control radio
   */
  density: {
    type: String,
    validator: (value) => densityOptions.includes(value),
    default: "default",
  },
  /**
   * Row frame. "outlined" draws each row as a separate bordered card with a gap between cards; "divided" stacks the rows with a line between them; "plain" stacks the rows with nothing between them.
   *
   * @type {String}
   * @default "outlined"
   * @values outlined, divided, plain
   * @storybook-control radio
   */
  variant: {
    type: String,
    validator: (value) => variantOptions.includes(value),
    default: "outlined",
  },
  /**
   * Where the grip and move buttons sit beside the row content. "center" centers them, for rows of one or two lines; "start" keeps them level with the first line, for rows that wrap to three or more lines.
   *
   * @type {String}
   * @default "center"
   * @values center, start
   * @storybook-control radio
   */
  controlsAlign: {
    type: String,
    validator: (value) => controlsAlignOptions.includes(value),
    default: "center",
  },
});
